document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(
    '[data-forms-id="forms-root-753887"]'
  );
  console.log("🚀 ~ formContainer:", formContainer)
  if (!formContainer) {
    return;
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    // Шукаємо форму всередині formContainer, щоб не залежати від зміни селекторів Shopify
    const form = formContainer.querySelector("shopify-forms-embed");
    console.log("🚀 ~ form:", form)

    if (form) {
      observer.disconnect();
      console.log("form found");
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();

      // Base input styles - matching nova-contact-form design
      sheet.insertRule(`
      input[type="text"],
      input[type="email"],
      input[type="tel"],
      input[type="number"],
      textarea,
      select {
        border: 0.1rem solid rgb(var(--layout-text-color)) !important;
        border-radius: 0 !important;
        padding: 8px 16px !important;
        font-size: 16px !important;
        line-height: 1.5 !important;
        background-color: rgb(var(--layout-background-color)) !important;
        color: rgb(var(--layout-text-color)) !important;
        transition: border-color 0.3s ease !important;
        
      }
    `);

      // Dropdown button specific styles
      sheet.insertRule(`
      div button[aria-expanded] {
        border: 0.1rem solid rgb(var(--layout-text-color)) !important;
        padding: 8px 32px !important;
        font-size: 16px !important;
        line-height: 1.5 !important;
        background-color: rgb(var(--layout-background-color)) !important;
        color: rgb(var(--layout-text-color)) !important;
        transition: border-color 0.3s ease !important;
        width: 100% !important;
      }
    `);
    sheet.insertRule(`
      ._textBody_2aowh_10 {
        font-size: 16px !important;
      }
    `);
    sheet.insertRule(`
      ._checkboxField_1hja3_3 {
        grid-template-columns: 2em minmax(0, 1fr);
      }
    `);
    sheet.insertRule(`
      ._checkboxWrapper_1hja3_33  {
       height: 100% !important;
      }
    `);
    sheet.insertRule(`
      ._checkboxWrapper_1hja3_33 input[type="checkbox"] {
        height: 100% !important;
        width: 100% !important;
      }
    `);

      // Input focus styles
      sheet.insertRule(`
      input[type="text"]:focus,
      input[type="email"]:focus,
      input[type="tel"]:focus,
      input[type="number"]:focus,
      textarea:focus,
      select:focus {
        border-color: rgb(var(--layout-text-color)) !important;
        outline: none !important;
        box-shadow: none !important;
      }
    `);

      // Dropdown button focus styles
      sheet.insertRule(`
      div button[aria-expanded]:focus {
        border-color: rgb(var(--layout-text-color)) !important;
        outline: none !important;
        box-shadow: none !important;
      }
    `);

      // Label styles - uppercase and bold
      sheet.insertRule(`
      label,
      ._selectContainer_12thd_6 p  {
        display: block ;
        margin-bottom: 8px !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        color: rgb(var(--layout-text-color)) !important;
        text-transform: uppercase !important;
        letter-spacing: 0.05em !important;
      }
    `);

      sheet.insertRule(`
      ._selectContainer_12thd_6 p  {
        font-size: 12px !important;
        font-weight: 700 !important;
        color: rgb(var(--layout-text-color)) !important;
        text-transform: uppercase !important;
        letter-spacing: 0.05em !important;
      }
    `);

      // Field wrapper styles with position relative
      sheet.insertRule(`
      div[class*="field"],
      div[class*="formField"] {
        position: relative !important;
        margin-bottom: 18px !important;
        width: 100% !important;
      }
    `);

      // Form field styles - column-reverse to put label on top
      sheet.insertRule(`
      div[class*="_formField"] {
        display: flex !important;
        flex-direction: column-reverse !important;
      }
    `);

      // Form field label styles
      sheet.insertRule(`
      div[class*="_formField"] label {
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
        transform: scale(1) !important;
      }
    `);

      // Remove before pseudo-element from textarea container
      sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        height: 0 !important;
      }
    `);

      // Phone input alignment
      sheet.insertRule(`
      ._formPhoneInputContainer_piv1u_6 {
        align-items: end !important;
      }
    `);

      // Input filled state positioning fix
    //   sheet.insertRule(`
    //   ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 {
    //     left: -96px !important;
    //   } 
    // `);

      // Form wrapper styles
      sheet.insertRule(`
      section[data-sizing="form-wrapper"] {
        max-width: 100% !important;
      }
    `);

      // Form gap between fields
      sheet.insertRule(`
      section[data-sizing="form-wrapper"] form {
        gap: 18px !important;
      }
    `);

      // Form spacing and layout
      sheet.insertRule(`
      form {
        display: flex !important;
        flex-direction: column !important;
        gap: 18px !important;
      }
    `);

      // Remove default margins
      sheet.insertRule(`
      section[data-sizing="form-wrapper"] form > * {
        margin: 0 !important;
      }
    `);

      // Select dropdown styles
      sheet.insertRule(`
      select {
        width: 100% !important;
        appearance: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        background-image: none !important;
        cursor: pointer !important;
        border-radius: 50px !important;
        padding-right: 3rem !important;
      }
    `);

      // Dropdown button (aria-expanded) - rounded like select, override padding
      sheet.insertRule(`
      div button[aria-expanded] {
        border-radius: 50px !important;
        padding-right: 3rem !important;
        text-align: left !important;
      }
    `);

      // Select/dropdown container positioning
      sheet.insertRule(`
      div:has(select),
      div:has(button[aria-expanded]) {
        position: relative !important;
      }
    `);

      // SVG icon positioning for select/dropdown (from nova-section-contact-form.css)
      sheet.insertRule(`
      div:has(select) svg,
      div:has(button[aria-expanded]) svg {
        position: absolute !important;
        right: 1.5rem !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        width: 1rem !important;
        height: auto !important;
        pointer-events: none !important;
        z-index: 1 !important;
      }
    `);

      // SVG fill color
      sheet.insertRule(`
      div:has(select) svg > *,
      div:has(button[aria-expanded]) svg > * {
        fill: rgb(var(--layout-text-color)) !important;
      }
    `);

      // Checkbox container wrapper styles
    //   sheet.insertRule(`
    //   div[class*="_checkboxWrapper"] {
    //     display: flex !important;
    //     align-items: flex-start !important;
    //     gap: 0.8rem !important;
    //     background-color: transparent !important;
    //     padding: 0 !important;
    //   }
    // `);

    //   // Checkbox styles - matching nova-section-contact-form
    //   sheet.insertRule(`
    //   input[type="checkbox"] {
    //     border: 0.1rem solid rgb(var(--layout-text-color)) !important;
    //     border-radius: 0 !important;
    //     width: 2rem !important;
    //     height: 2rem !important;
    //     min-width: 2rem !important;
    //     min-height: 2rem !important;
    //     flex-shrink: 0 !important;
    //     appearance: none !important;
    //     -webkit-appearance: none !important;
    //     -moz-appearance: none !important;
    //     background-color: transparent !important;
    //     background-image: none !important;
    //     cursor: pointer !important;
    //     margin: 0 !important;
    //     padding: 0 !important;
    //   }
    // `);

    //   // Checkbox checked state
    //   sheet.insertRule(`
    //   input[type="checkbox"]:checked {
    //     border-color: rgb(var(--accent-button-color)) !important;
    //     background-color: transparent !important;
    //     background-image: none !important;
    //   }
    // `);

    //   // Checkbox checked mark
    //   sheet.insertRule(`
    //   input[type="checkbox"]:checked::after {
    //     content: "✓" !important;
    //     display: flex !important;
    //     align-items: center !important;
    //     justify-content: center !important;
    //     font-size: 1.4rem !important;
    //     color: rgb(var(--accent-button-color)) !important;
    //     font-weight: 700 !important;
    //     width: 100% !important;
    //     height: 100% !important;
    //   }
    // `);

    //   // Checkbox hover/focus states - keep transparent
    //   sheet.insertRule(`
    //   input[type="checkbox"]:hover,
    //   input[type="checkbox"]:focus {
    //     background-color: transparent !important;
    //     background-image: none !important;
    //   }
    // `);

    //   // Field wrapper for checkbox - horizontal layout
    //   sheet.insertRule(`
    //   div[class*="field"]:has(input[type="checkbox"]) {
    //     flex-direction: row !important;
    //     align-items: flex-start !important;
    //     gap: 0.8rem !important;
    //     margin-bottom: 16px !important;
    //     background-color: transparent !important;
    //   }
    // `);

    //   // Checkbox label - not uppercase, normal weight
    //   sheet.insertRule(`
    //   div[class*="field"]:has(input[type="checkbox"]) label {
    //     margin-bottom: 0 !important;
    //     font-size: 14px !important;
    //     font-weight: 400 !important;
    //     line-height: 1.5 !important;
    //     text-transform: none !important;
    //     letter-spacing: normal !important;
    //     cursor: pointer !important;
    //     flex: 1 !important;
    //     background-color: transparent !important;
    //   }
    // `);

    //   // Remove any background from checkbox parent divs
    //   sheet.insertRule(`
    //   div:has(> input[type="checkbox"]) {
    //     background-color: transparent !important;
    //     background-image: none !important;
    //   }
    // `);
    // sheet.insertRule(`
    //   ._consentCheckboxContainer_cit2d_49 label {
    //     display: flex !important;
    //     }`);

      // Remove backgrounds from all wrapper divs
      sheet.insertRule(`
      div[class*="Wrapper"],
      div[class*="wrapper"],
      div[class*="Container"],
      div[class*="container"] {
        background-color: transparent !important;
        background-image: none !important;
      }
    `);

      // Ensure all inputs and buttons have proper backgrounds
      sheet.insertRule(`
      input,
      select,
      textarea,
      button {
        background-image: none !important;
      }
    `);

      // Force remove any hover/active backgrounds from inputs
      sheet.insertRule(`
      input:hover,
      input:active,
      select:hover,
      select:active,
      textarea:hover,
      textarea:active {
        background-image: none !important;
      }
    `);

      // Force transparent background for all checkbox-related elements
      sheet.insertRule(`
      *[class*="checkbox"],
      *[class*="Checkbox"] {
        background-color: transparent !important;
        background-image: none !important;
      }
    `);

      // Textarea specific styles
      sheet.insertRule(`
      textarea {
        min-height: 150px !important;
        resize: vertical !important;
        font-family: inherit !important;
        border-radius: 0 !important;
      }
    `);

      // Override any border-radius for text inputs specifically
      sheet.insertRule(`
      input[type="text"],
      input[type="email"],
      input[type="tel"],
      input[type="number"] {
        border-radius: 0 !important;
      }
    `);

      // Link styles in labels - blue underlined
      sheet.insertRule(`
      label a,
      span a {
        color: #0066cc !important;
        text-decoration: underline !important;
        cursor: pointer !important;
      }
    `);

      // Link hover styles
      sheet.insertRule(`
      label a:hover,
      span a:hover {
        opacity: 0.8 !important;
      }
    `);

      // Button styles - black background, white text, full width
      sheet.insertRule(`
      button[type="submit"] {
        background-color: rgb(var(--layout-text-color)) !important;
        color: rgb(var(--layout-background-color)) !important;
        border: none !important;
        border-radius: 0 !important;
        padding: 1.5rem 2rem !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        cursor: pointer !important;
        transition: opacity 0.3s ease !important;
      }
    `);

      // Button hover styles
      sheet.insertRule(`
      button[type="submit"]:hover {
        opacity: 0.8 !important;
      }
    `);

      // Success message styles
      sheet.insertRule(`
      div[class*="success"],
      div[class*="status"] {
        padding: 1rem !important;
        margin-bottom: 20px !important;
        font-size: 14px !important;
        background-color: #d4edda !important;
        border: 1px solid #c3e6cb !important;
        color: #155724 !important;
      }
    `);

      // Error message styles
      sheet.insertRule(`
      div[class*="error"],
      div[class*="error"] p {
        color: #dc3545 !important;
        font-size: 14px !important;
        margin-top: 0.5rem !important;
      }
    `);

      // Help text at bottom (hCaptcha disclaimer)
      sheet.insertRule(`
      p {
        font-size: 12px !important;
        line-height: 1.5 !important;
        color: rgb(var(--layout-text-color)) !important;
      }
    `);

      // Responsive adjustments
      sheet.insertRule(`
      @media screen and (min-width: 769px) {
        input[type="text"],
        input[type="email"],
        input[type="tel"],
        input[type="number"],
        textarea {
          border-radius: 0 !important;
        }
      }
    `);
    sheet.insertRule(`
      ._selectToggleText_12thd_25 {
       min-height: 32px !important;
      }
    `);
    sheet.insertRule(`
      fieldset[name="custom#terms_and_conditions"] legend {
        display: none !important;
      }
    `);

      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add("loaded");

      // Replace text in square brackets with links
      const processLinks = () => {

        // find all links in the shadow DOM
        const links = shadow.querySelectorAll('a');
        links.forEach(link => {
          link.target = '_blank';
        });

        // Find all spans in the shadow DOM
        const spans = shadow.querySelectorAll('span._textBody_2aowh_10');
        
        spans.forEach(span => {
          const text = span.innerHTML;
          
          // Check if text contains square brackets
          if (text.includes('[') && text.includes(']')) {
            // Define link mappings - you can customize these URLs
            const linkMappings = {
              'Terms and Conditions': '/pages/terms-and-conditions',
              'Privacy Policy': '/policies/privacy-policy',
              'Terms of Service': '/policies/terms-of-service'
            };
            
            // Replace text in square brackets with links
            let newText = text.replace(/\[([^\]]+)\]/g, (match, linkText) => {
              const url = linkMappings[linkText] || '#';
              return `<a href="${url}" target="_blank" style="color: #0066cc; text-decoration: underline;">${linkText}</a>`;
            });
            
            span.innerHTML = newText;
          }
        });
      };

      // Call the function to replace links
      processLinks();

      // 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
